export { AboutTheProduct } from "./AboutTheProduct";
export type {
	AboutTheProductProps,
	AboutProductContent,
	AboutProductSectionKey
} from "./AboutTheProduct";
